// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthReservation\ApiBerthReservationVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthReservationSelf, BerthReservationSelfData, BerthReservationSelfOptions } from 'data/models/BerthReservationSelf';
import { BerthReservationVersion as _BerthReservationVersion, BerthReservationVersionData as _BerthReservationVersionData, BerthReservationVersionOptions as _BerthReservationVersionOptions } from 'data/models/BerthReservationVersion';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';
import { BerthReservationStatus, VesselSide } from 'server/enums/BerthReservation';

// BerthReservationVersionData is the class that BerthReservationVersion serializes to/from
export interface BerthReservationVersionData {
    ChangeId : number;
    Id : number;
	
    Change : ChangeData | null;
    EventsAbout : EventData[] | null;
    EventsReferencing : EventData[] | null;
    NextVersion : _BerthReservationVersionData[] | null;
    PrevChange : ChangeData | null;
    PrevChangeId : number | null;
    PrevVersion : _BerthReservationVersionData | null;
    Self : BerthReservationSelfData | null;
	
    ApprovedDate : /* ISO8601 */ string | null;
    CancellationRemarks : string | null;
    CancelledDate : /* ISO8601 */ string | null;
    ConflictCount : number;
    Deleted : boolean;
    ExtraDataJSON : string | null;
    Footmark : MeasurementData;
    Guid : /* GUID */ string;
    Length : MeasurementData;
    Rafting : boolean;
    RequestDate : /* ISO8601 */ string;
    SideTo : VesselSide;
    Status : BerthReservationStatus;
}

// BerthReservationVersionOptions is the class which may be passed to the BerthReservationVersion constructor to define optional initial data values
export interface BerthReservationVersionOptions {
    ChangeId : number;
    Id : number;
	
    Change? : ChangeOptions | null;
    EventsAbout? : EventOptions[] | null;
    EventsReferencing? : EventOptions[] | null;
    NextVersion? : _BerthReservationVersionOptions[] | null;
    PrevChange? : ChangeOptions | null;
    PrevChangeId? : number | null;
    PrevVersion? : _BerthReservationVersionOptions | null;
    Self? : BerthReservationSelfOptions | null;
	
    ApprovedDate? : /* ISO8601 */ string | null;
    CancellationRemarks? : string | null;
    CancelledDate? : /* ISO8601 */ string | null;
    ConflictCount? : number;
    Deleted? : boolean;
    ExtraDataJSON? : string | null;
    Footmark? : MeasurementOptions;
    Guid? : /* GUID */ string;
    Length? : MeasurementOptions;
    Rafting? : boolean;
    RequestDate? : /* ISO8601 */ string;
    SideTo? : VesselSide;
}

export class BerthReservationVersion {
    public ChangeId : DataSignal<number>;
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public EventsAbout : SDataArray<Event>;
    public EventsReferencing : SDataArray<Event>;
    public NextVersion : SDataArray<_BerthReservationVersion>;
    public PrevChange : DataSignal<Change | null>;
    public PrevChangeId : DataSignal<number | null>;
    public PrevVersion : DataSignal<_BerthReservationVersion | null>;
    public Self : DataSignal<BerthReservationSelf | null>;
	
    public ApprovedDate : DataSignal<TZDate | null>;
    public CancellationRemarks : DataSignal<string | null>;
    public CancelledDate : DataSignal<TZDate | null>;
    public ConflictCount : DataSignal<number>;
    public Deleted : DataSignal<boolean>;
    public ExtraDataJSON : DataSignal<string | null>;
    public Footmark : Measurement;
    public Guid : DataSignal<string>;
    public Length : Measurement;
    public Rafting : DataSignal<boolean>;
    public RequestDate : DataSignal<TZDate>;
    public SideTo : DataSignal<VesselSide>;

    constructor();
    constructor(data : BerthReservationVersionOptions);
    constructor(data: BerthReservationVersionOptions | null = null) {
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.EventsAbout = SArray<Event>([]);
        this.EventsReferencing = SArray<Event>([]);
        this.NextVersion = SArray<_BerthReservationVersion>([]);
        this.PrevChange = S.value<Change | null>(null);
        this.PrevChangeId = jsonableObservable(S.value<number | null>(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = S.value<_BerthReservationVersion | null>(null);
        this.Self = S.value<BerthReservationSelf | null>(null);
	    
        this.ApprovedDate = jsonableObservable(S.value<TZDate | null>(data && data.ApprovedDate !== undefined ? data.ApprovedDate === null ? null : new TZDate(data.ApprovedDate) : null, TZDate.nullableEq));
        this.CancellationRemarks = jsonableObservable(S.value<string | null>(data && data.CancellationRemarks !== undefined ? data.CancellationRemarks : null));
        this.CancelledDate = jsonableObservable(S.value<TZDate | null>(data && data.CancelledDate !== undefined ? data.CancelledDate === null ? null : new TZDate(data.CancelledDate) : null, TZDate.nullableEq));
        this.ConflictCount = jsonableObservable(S.value<number>(data && data.ConflictCount !== undefined ? data.ConflictCount : 0));
        this.Deleted = jsonableObservable(S.value<boolean>(data && data.Deleted !== undefined ? data.Deleted : false));
        this.ExtraDataJSON = jsonableObservable(S.value<string | null>(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement(data.Footmark) : new Measurement();
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Length = data && data.Length !== undefined ? new Measurement(data.Length) : new Measurement();
        this.Rafting = jsonableObservable(S.value<boolean>(data && data.Rafting !== undefined ? data.Rafting : false));
        this.RequestDate = jsonableObservable(S.value<TZDate>(data && data.RequestDate !== undefined ? new TZDate(data.RequestDate) : new TZDate(0), TZDate.eq));
        this.SideTo = jsonableObservable(S.value<VesselSide>(data && data.SideTo !== undefined ? data.SideTo : 0));
    }

    static key(obj : BerthReservationVersion) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    }
    
    static dataKey(obj : BerthReservationVersionOptions) {
        return obj.ChangeId + '\u2618' + obj.Id;
    }

    static update(obj : BerthReservationVersion, data : BerthReservationVersionOptions) {
        S.freeze(() => {
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.PrevChangeId !== undefined) obj.PrevChangeId(data.PrevChangeId);
	        
            if (data.ApprovedDate !== undefined) obj.ApprovedDate(data.ApprovedDate === null ? null : new TZDate(data.ApprovedDate));
            if (data.CancellationRemarks !== undefined) obj.CancellationRemarks(data.CancellationRemarks);
            if (data.CancelledDate !== undefined) obj.CancelledDate(data.CancelledDate === null ? null : new TZDate(data.CancelledDate));
            if (data.ConflictCount !== undefined) obj.ConflictCount(data.ConflictCount);
            if (data.Deleted !== undefined) obj.Deleted(data.Deleted);
            if (data.ExtraDataJSON !== undefined) obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Footmark !== undefined) Measurement.update(obj.Footmark, data.Footmark);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Length !== undefined) Measurement.update(obj.Length, data.Length);
            if (data.Rafting !== undefined) obj.Rafting(data.Rafting);
            if (data.RequestDate !== undefined) obj.RequestDate(new TZDate(data.RequestDate));
            if (data.SideTo !== undefined) obj.SideTo(data.SideTo);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthReservationVersion.ts